var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSplitMerge = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 20,
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.6,
  d: "m8.333 14.167 4.167-4.166-4.167-4.167M12.5 10h-10M12.5 2.5h3.333A1.666 1.666 0 0 1 17.5 4.167v11.666a1.666 1.666 0 0 1-1.667 1.667H12.5M31.667 14.167 27.5 10.001l4.167-4.167M27.5 10h10M27.5 2.5h-3.333A1.666 1.666 0 0 0 22.5 4.167v11.666a1.666 1.666 0 0 0 1.667 1.667H27.5"
})));
SvgSplitMerge.viewBox = null;
const ForwardRef = /*#__PURE__*/forwardRef(SvgSplitMerge);
export default ForwardRef;